// ** MUI Imports
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { Switch } from "@mui/material";

const PageHeader = (props) => {
  // ** Props
  const { title, refreshVideo, isVideo, isFitra, setFitraOnOff, status } =
    props;
  const theme = useTheme();

  return (
    <Grid item xs={12}>
      <Box
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: isFitra ? "flex-start" : "space-between",
          display: "flex",
        }}
      >
        {title}

        {isVideo && (
          <Button
            type="submit"
            variant="contained"
            size="medium"
            style={{ backgroundColor: theme.palette.primary.main }}
            onClick={refreshVideo}
          >
            Refresh Video
          </Button>
        )}
        {isFitra && (
          <Switch
            checked={status}
            size={"small"}
            style={{ color: theme.palette.primary.light }}
            onChange={setFitraOnOff}
          />
        )}
      </Box>
    </Grid>
  );
};

PageHeader.defaultProps = {
  isVideo: false,
};

export default PageHeader;
